import AppLayout from "../../../../shared/components/AppLayout";
import BackendUnavailablePage from "../../../../shared/components/BackendUnavailablePage";
import Button from "../../../../shared/components/Button";
import EmptyState from "../../../../shared/components/EmptyState";
import LoadingPage from "../../../../shared/components/LoadingPage";
import { siteTexts } from "../../../../shared/i18n/siteTexts";
import { useSiteContent } from "../../../home/shared/hooks/useSiteContent";
import "../../../../shared/components/ContentCard.css";

type ProductDetailPageProps = {
  productId: string;
};

export default function ProductDetailPage({ productId }: ProductDetailPageProps) {
  const { content, loading, backendUnavailable, refresh } = useSiteContent();
  if (loading) {
    return <LoadingPage label={siteTexts.common.loading} />;
  }
  if (backendUnavailable) {
    return <BackendUnavailablePage onRetry={refresh} />;
  }
  const index = Number(productId);
  const product = Number.isNaN(index) ? null : content.products[index] || null;

  if (!product) {
    return (
      <AppLayout title={siteTexts.shop.notFound.title}>
        <EmptyState
          message={siteTexts.shop.notFound.message}
          action={
            <Button variant="primary" href="#/loja">
              {siteTexts.shop.notFound.action}
            </Button>
          }
        />
      </AppLayout>
    );
  }

  return (
    <AppLayout title={product.title} subtitle={siteTexts.shop.detailsSubtitle}>
      <div className="card">
        <div
          className="card-media"
          style={
            product.imageUrl ? { backgroundImage: `url(${product.imageUrl})` } : undefined
          }
        />
        <div className="card-body">
          <span className="card-tag">{product.price || siteTexts.shop.priceFallback}</span>
          <p>{product.description}</p>
          <Button variant="primary" href="#/loja">
            {siteTexts.shop.backToList}
          </Button>
        </div>
      </div>
    </AppLayout>
  );
}
